import moment from 'moment';
import 'moment-timezone';
import { momentLocalizer } from 'react-big-calendar';
import { isValidTimeZone } from './timeZone';

/**
 * O localizer oficial do react-big-calendar usa a funcao Moment recebida para
 * toda a aritmetica. Este proxy cria instancias sempre no fuso da clinica sem
 * alterar moment.tz.setDefault(), que e global ao processo e vazava entre
 * tenants/componentes.
 */
export const createAgendaTimeZoneLocalizer = (timeZone: string) => {
  if (!isValidTimeZone(timeZone)) {
    throw new Error('Fuso horário IANA inválido para a agenda.');
  }

  const scopedMoment = new Proxy(moment, {
    apply(_target, _thisArg, args: unknown[]) {
      if (args.length === 0) return moment.tz(timeZone);

      // O único parse civil do localizer ocorre em merge(date, time), com uma
      // string e um formato. Interpretá-lo diretamente no tenant evita passar
      // primeiro pelo fuso do navegador.
      if (typeof args[0] === 'string' && args.length > 1) {
        return (moment.tz as (...values: unknown[]) => moment.Moment)(...args, timeZone);
      }

      return moment(args[0] as moment.MomentInput).tz(timeZone);
    },
  }) as typeof moment;

  const localizer = momentLocalizer(scopedMoment);
  const offsetAt = (value: Date) => -moment.tz(value, timeZone).utcOffset();

  // Date#getTimezoneOffset sempre usa o navegador. Sobrescrever estes dois
  // pontos mantém também a compensacao de DST no fuso explícito da clínica.
  localizer.getTimezoneOffset = offsetAt;
  localizer.getDstOffset = (start: Date, end: Date) => offsetAt(start) - offsetAt(end);

  return localizer;
};
